import { useMemo } from 'react';
import { InternalLink, InternalLinkBlock, LinkBlockLink, LinkBlockList } from '../@types/schema';

const MAPPINGS = [
  { title: 'subject_title', links: 'subject_links' },
  { title: 'lo_tutoring_title', links: 'lo_tutoring_links' },
  { title: 'ls_tutoring_title', links: 'ls_tutoring_links' },
];

const mapToInternalLinks = (links: LinkBlockLink[]): InternalLink[] =>
  links.map((link) => ({ link: link.url, label: link.text }));

/**
 * Converts (memoized) link blocks received from VTWA into an array of internal links and titles
 * for use with the `InternalLinks` component.
 */
const useLinkBlocksAsInternalLinks = (linkBlockList: LinkBlockList) =>
  useMemo(() => {
    const output: InternalLinkBlock[] = [];
    if (!linkBlockList) return output;

    for (const { title, links } of MAPPINGS) {
      if (linkBlockList[links]?.length) {
        output.push({
          title: linkBlockList[title],
          internalLinks: mapToInternalLinks(linkBlockList[links]),
        });
      }
    }

    return output;
  }, [linkBlockList]);

export default useLinkBlocksAsInternalLinks;
